import V1Adapter from './V1Adapter';
import V2Adapter from './V2Adapter';
import { MasterpassAdapter, MasterpassVersion } from './Types';

export * from './Types';
export { default as V1Adapter } from './V1Adapter';
export { default as V2Adapter } from './V2Adapter';
export { normalizeV1Card, toV2Response } from './V1Adapter';
export { defaultTerminalGroupId } from './TerminalGroup';

/**
 * Sürüme karşılık gelen adaptörü döndürür.
 *
 * ⚠️ SÜRÜM İŞLEM BAŞINDA SABİTLENİR. Token cevabındaki `IsVersion2Active`
 * okunduğu anda seçilen adaptör, o işlemin sonuna kadar kullanılmalıdır.
 * Backend anahtarı işlemin ortasında çevirirse (örn. 3D/OTP adımları arasında)
 * akış yarıda sürüm değiştirir ve doğrulama adımı hiçbir zaman tamamlanmaz;
 * OTP/3D akışlarında ikinci adım daima ilk adımı başlatan SDK'ya gitmelidir.
 */
export const getMasterpassAdapter = (version: MasterpassVersion): MasterpassAdapter =>
  version === 'v2' ? V2Adapter : V1Adapter;

/**
 * Sürüm bayrağını uygulama içi sürüm tipine çevirir.
 *
 * ⚠️ STRING DE KABUL EDER. Web akışında değer `isMasterpassVersion2()` ile
 * çözülmüş bir boolean olarak gelir; mobil WebView akışında ise adres çubuğundan
 * ham string (`"true"` / `"false"`) olarak okunur. Doğrudan doğruluk kontrolü
 * yapmak `"false"` string'ini DOĞRU sayardı.
 */
export const toMasterpassVersion = (isVersion2Active?: boolean | string | null): MasterpassVersion => {
  if (typeof isVersion2Active === 'string') {
    return isVersion2Active.trim().toLowerCase() === 'true' ? 'v2' : 'v1';
  }

  return isVersion2Active ? 'v2' : 'v1';
};
